import React from "react";

type IconHouseProps = {
  width?: number;
  height?: number;
};

const defaultIconHouseProps: IconHouseProps = {
  width: 96,
  height: 96,
};

export const IconHouse = ({
  width = defaultIconHouseProps.width,
  height = defaultIconHouseProps.height,
}: IconHouseProps) => {
  return (
    <img
      data-id="icon-house"
      src="https://www.originenergy.com.au/wp-content/uploads/252/spot_house_contained-white.svg"
      alt=""
      width={width}
      height={height}
    />
  );
};
